// extracted by mini-css-extract-plugin
export default {"header":"header__DTK6R","active":"active__DToWY"};